export default class Alert {
    constructor( public message?:string ) {
    }
    set( message?:string, timeout?:number ) : Alert {
        this.message = message;
        console.log(this.message);
        return this;
    }
}
